/** Anything other than the Pog we last stamped is somebody else's write. */
import type { Pog } from "@CommonTypes/merchflow/pog/pog";

export type PogAuthor = "original" | "studio" | "external";

export const pogAuthorOf = (
  pog: Pog | null,
  originalPog: Pog | null,
  lastStamped: Pog | null,
): PogAuthor => {
  if (pog !== null && pog === lastStamped) return "studio";
  if (pog === originalPog) return "original";
  return "external";
};

/** Re-applying steps over someone else's plan would un-revert it. */
export const shouldStandDown = (
  previewOn: boolean,
  pog: Pog | null,
  originalPog: Pog | null,
  lastStamped: Pog | null,
): boolean => previewOn && pogAuthorOf(pog, originalPog, lastStamped) === "external";

export type HistoryPreviewFollowUp = "restore-original" | "reapply" | "stand-down" | "none";

/** Measured before the undo lands — 1 means return to the untouched plan. */
export const historyPreviewFollowUp = (
  direction: "undo" | "redo",
  previewOn: boolean,
  undoDepthBefore: number,
): HistoryPreviewFollowUp => {
  if (direction === "redo") return "reapply";
  if (undoDepthBefore <= 1) return "restore-original";
  return previewOn ? "reapply" : "none";
};

export const historyPreviewFollowUpFor = (
  direction: "undo" | "redo",
  previewOn: boolean,
  undoDepthBefore: number,
  author: PogAuthor,
): HistoryPreviewFollowUp => {
  const followUp = historyPreviewFollowUp(direction, previewOn, undoDepthBefore);
  if (author !== "external" || followUp === "none") return followUp;
  return "stand-down";
};
